import queryString from 'query-string';
import _, { has } from 'lodash';
import appConfig from '../appConfig';
import {
  showExternalAsMain,
  showSearchAsMain,
  showAdminAsMain,
  showCategoryFileUploader,
} from '../actions/mainUI';
import piction, { createTemplateURL, getLanguageFromLocale } from './piction';
import { validateSessionConnection } from '../actions/session';
import { addIntlError, addIntlInfo } from '../actions/messageDialog';
import { locale } from 'core-js';

// eslint-disable-next-line no-undef
const pathPrefix = __DEV__ ? './' : './';

export const allowDropHandler = (e) => {
  e.preventDefault();
};

export const getUrlVars = () => {
  const vars = [];
  let hash;
  const hashes = window.location.href
    .slice(window.location.href.indexOf('?') + 1)
    .split('&');
  for (let i = 0; i < hashes.length; i++) {
    hash = hashes[i].split('=');
    vars.push(hash[0]);
    vars[hash[0]] = decodeURIComponent(hash[1]);
  }
  vars.surl = sessionStorage.getItem('surl') || '';
  vars.token = sessionStorage.getItem('token');
  vars.locale = sessionStorage.getItem('locale');

  return vars;
};

export const launchWindow = (url, dispatch, overrideConfig = {}) => {
  const surl = piction.session.surl;
  dispatch(validateSessionConnection(surl)).then((res) => {
    if (res.isValid) {
      const defaultConfig = {
        width: 1080,
        height: 800,
        toolbar: 'no',
        location: 'no',
        menubar: 'no',
        scrollbars: 'yes',
        resizable: 'no',
      };
      const config = { ...defaultConfig, ...overrideConfig };
      const configAsArray = Object.keys(config).map(
        (prop) => `${prop}=${config[prop]}`
      );
      return window.open(url, '_blank', configAsArray.join(','));
    }
    return null;
  });
};

export const openExternalLink = (url, openInCurTab = false) =>
  window.open(url, openInCurTab ? '_self' : '_blank');

/* downloads a given URL
 * @param fileURL - downloadable url
 * @param fieName - fileName to prompt
 */
export const downloadFile = (fileURL, fileName) => {
  const save = document.createElement('a');
  save.href = fileURL;
  const filename = fileURL.substring(fileURL.lastIndexOf('/') + 1);
  save.download = fileName || filename;
  if (navigator.msSaveBlob) {
    // for IE < 11
    document.body.appendChild(save);
    save.click();
  } else {
    save.target = '_blank';
    if (
      navigator.userAgent.toLowerCase().match(/(ipad|iphone|safari)/) &&
      navigator.userAgent.search('Chrome') < 0
    ) {
      document.location = save.href;
    } else {
      // window event not working here
      const evt = new MouseEvent('click', {
        view: window,
        bubbles: true,
        cancelable: false,
      });
      save.dispatchEvent(evt);
      (window.URL || window.webkitURL).revokeObjectURL(save.href);
    }
  }
};

export const embedExternalScript = (url, isCSS, isAsync, id, dataset) => {
  const head = document.getElementsByTagName('head')[0];
  let customEl;

  if (isCSS) {
    customEl = document.createElement('link');
    customEl.type = 'text/css';
    customEl.href = url;
    customEl.rel = 'stylesheet';
  } else {
    customEl = document.createElement('script');
    customEl.type = 'text/javascript';
    customEl.src = url;
  }
  customEl.async = isAsync;

  customEl.id = id;
  dataset && Object.keys(dataset).forEach(i => customEl.dataset[i] = dataset[i]);

  head.append(customEl);
}

export const oldExportDownload = async (url, isExt = false) => {
  // creating a form to open new window with POST action
  const form = document.createElement('form');
  form.setAttribute('method', 'post');
  form.setAttribute('action', url);
  if (navigator.msSaveBlob && !isExt) {
    // for IE
    form.setAttribute('target', '_self');
  } else {
    form.setAttribute('target', '_blank');
  }

  // put the params as hidden input fields- for security purposes
  const hiddenField = document.createElement('input');
  hiddenField.setAttribute('type', 'hidden');
  hiddenField.setAttribute('name', 'surl');
  hiddenField.setAttribute('value', piction.session._surl || '');
  form.appendChild(hiddenField);
  const hiddenField2 = document.createElement('input');
  hiddenField2.setAttribute('type', 'hidden');
  hiddenField2.setAttribute('name', 'csrf');
  hiddenField2.setAttribute('value', piction.session._token);
  form.appendChild(hiddenField2);

  // Append and submit
  document.body.appendChild(form);
  form.submit();
};

export const downloadExportFile = async (url, dispatch) => {
  try {
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        surl: piction.session._surl,
        csrf: piction.session._token,
      }),
    });

    const contentType = response.headers.get('Content-Type');

    if (!response.ok) {
      throw new Error('Server error during download.');
    }

    if (contentType.includes('text/html')) {
      const data = await response.text();
      console.log('Error:', data);
      dispatch(addIntlError('general.error'));
    } else if (contentType.includes('application/json')) {
      const data = await response.json();
      console.log('Download response:', data);
      dispatch(addIntlInfo('workspaceDownloadDialog.autoEmailDownload'));
    } else { // contentType.includes('application/x-zip-compressed')
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');

      // Optionally get filename from headers
      const disposition = response.headers.get('Content-Disposition');
      let filename = 'downloaded_media';

      if (disposition && disposition.includes('filename=')) {
        filename = disposition.split('filename=')[1].replace(/"/g, '');
      }

      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    }
  } catch (error) {
    console.error('Download error:', error);
    dispatch(addIntlError('general.error'));
  }
};

export const createBasketUrl = (templateName, params, locale) => {
  let paramsQueryString = `${_.map(params, (value) =>
    _.isArray(Object.values(value)[0])
      ? Object.values(value)[0]
          .map((valID) => `${Object.keys(value)[0]}=${valID}`)
          .join('&')
      : `${Object.keys(value)[0]}=${Object.values(value)[0]}`
  ).join('&')}`;

  if (locale && getLanguageFromLocale(locale)) {
    paramsQueryString += `&LANGUAGE=${getLanguageFromLocale(locale)}`;
  }
  return `${appConfig.hostURL}!tpl.private_page?&acid=&name=${templateName}&${paramsQueryString}`;
};

export const showBasket = (
  dispatch,
  workspaceID,
  umoList,
  isSelectAll,
  locale
) => {
  const surl = piction.session.surl;
  const params = [];
  if (isSelectAll) {
    params.push({ LIGHTBOX_ID: workspaceID });
  }
  if (umoList) {
    params.push({ UMO_IDS: umoList.map((umoID) => `${umoID}`).join(',') });
  }

  dispatch(
    showExternalAsMain(
      createBasketUrl(appConfig.templates.basket.name, params, locale),
      surl
    )
  );
};

export const showPhotoBasket = (
  dispatch,
  workspaceID,
  umoList,
  isSelectAll,
  locale
) => {
  const surl = piction.session.surl;
  const params = [];
  if (isSelectAll) {
    params.push({ LIGHTBOX_ID: workspaceID });
  }
  if (umoList) {
    params.push({ UMO_IDS: umoList.map((umoID) => `${umoID}`).join(',') });
  }

  dispatch(
    showExternalAsMain(
      createBasketUrl(appConfig.templates.photoBasket.name, params, locale),
      surl
    )
  );
};

export const showAuthWorkflowTemplate = (dispatch, locale) => {
  const surl = piction.session.surl;
  dispatch(
    showExternalAsMain(
      createTemplateURL(
        appConfig.templates.authoriseWorkflow.name,
        undefined,
        locale
      ),
      surl
    )
  );
};

export const showWorkflowDashTemplate = (dispatch, locale) => {
  const surl = piction.session.surl;
  const url = createTemplateURL(
    appConfig.templates.workflowDashboard.name,
    undefined,
    locale
  );
  if (appConfig.openWorkflowDashboardExternally) {
    const $extForm = document.getElementById('external-content__form');
    // re-set the params- to prevent opening in new tab
    $extForm.target = 'external-content';
    $extForm.action = url;
    $extForm.method = 'POST';
    window.open('', 'external-content');
    $extForm.submit();
  } else {
    dispatch(showExternalAsMain(url, surl));
  }
};

export const showUploadTemplate = (dispatch, categoryID, categoryName) => {
  sessionStorage.setItem('destination', appConfig.hostURL);
  if (dispatch) {
    dispatch(showCategoryFileUploader(categoryID, categoryName, true));
  }
};

export const showWorkspaceLoader = (dispatch, workspaceID) => {
  dispatch(
    showExternalAsMain(
      createTemplateURL(appConfig.templates.workspaceUpload.name, {
        LIGHTBOX_ID: workspaceID,
      })
    )
  );
};

export const showManageCatRolesScreen = (dispatch, editable) => {
  const params = {
    edit: editable,
    categoriesSortByCC: appConfig.categoriesSortByCC,
  };

  const url = `${pathPrefix}external-tools/category-roles/index.html?`;

  if (dispatch) {
    dispatch(
      showAdminAsMain(
        `${url}${queryString.stringify(params)}`,
        piction.session.surl
      )
    );
  }
};

export const showSearch = (dispatch) => {
  dispatch(showSearchAsMain());
};

export const showCropTool = (umo, dispatch) => {
  const params = {
    id: umo.id,
  };

  window.open(
    `${pathPrefix}external-tools/image-cropper/index.html?${queryString.stringify(
      params
    )}`,
    '_blank'
  );
};

export const showUsersAndRolesScreen = (dispatch) => {
  const url = `${pathPrefix}external-tools/users-and-roles/index.html?`;
  const params = {
    dateFormat: appConfig.dateFormat,
  };

  if (dispatch) {
    dispatch(showAdminAsMain(`${url}${queryString.stringify(params)}`, piction.session.surl));
  } else {
    launchWindow(`${url}${queryString.stringify(params)}`, dispatch);
  }
};

export const showAudioAnnotatorTool = (umo, dispatch) => {
  const params = {
    umoid: umo.id,
    tagID: appConfig.advanced.audioAnnotationMetatag,
  };

  launchWindow(
    `${pathPrefix}external-tools/audio-annotator/index.html?${queryString.stringify(
      params
    )}`,
    dispatch
  );
};

export const showVideoAnnotatorTool = (umo, dispatch) => {
  const params = {
    umoid: umo.id,
    tagID: appConfig.advanced.audioAnnotationMetatag,
    isVideo: true,
  };

  launchWindow(
    `${pathPrefix}external-tools/audio-annotator/index.html?${queryString.stringify(
      params
    )}`,
    dispatch
  );
};

export const showVideoTrimmerTool = (umo, dispatch) => {
  const params = {
    u: umo.id,
    type: 'share',
  };

  launchWindow(
    `${pathPrefix}external-tools/video-trimmer/index.html?${queryString.stringify(
      params
    )}`,
    dispatch
  );
};

export const showMetaEditTool = (umo, dispatch) => {
  const url = `${pathPrefix}external-tools/meta-edit/index.html?`;
  const surl = piction.session.surl;
  const params = {
    dateFormat: appConfig.dateFormat,
    enableCCListEdit: appConfig.advanced.enableCCListEdit,
  };

  if (!umo) {
    params.type = 'mass-edit';
    dispatch(showAdminAsMain(`${url}${queryString.stringify(params)}`, surl));
  } else {
    params.umoid = umo.id;
    launchWindow(`${url}${queryString.stringify(params)}`, dispatch);
  }
};

export const showLoaderTool = (dispatch) => {
  const url = `${pathPrefix}external-tools/loader-tool/index.html`;
  const surl = piction.session.surl;
  dispatch(showAdminAsMain(url, surl));
};

export const showExportMetaTool = (dispatch) => {
  const url = `${pathPrefix}external-tools/import-metadata/index.html`;
  const surl = piction.session.surl;
  dispatch(showAdminAsMain(url, surl));
};

export const showNewRecordTool = (dispatch) => {
  const url = `${pathPrefix}external-tools/relational-tool/index.html?`;
  const params = {
    dateFormat: appConfig.dateFormat,
  };

  launchWindow(`${url}${queryString.stringify(params)}`, dispatch);
};

export const showImageAnnotatorTool = (umo, dispatch) => {
  const url = `${pathPrefix}external-tools/image-annotator/index.html?`;
  const params = {
    umoid: umo.id,
  };

  launchWindow(`${url}${queryString.stringify(params)}`, dispatch, {
    width: 1400,
    height: 900,
  });
};

export const showUmoExternalLink = (dispatch, link, umoID, params) => {
  const p = { umoID, ...params };
  const url = `${link}?${queryString.stringify(p)}`;
  dispatch(showAdminAsMain(url, piction.session.surl));
};

export const getLabelFromAppConfig = (
  configData = {},
  locale,
  labelKey = 'label'
) => {
  const labelLocaleKey = `${labelKey}Locale`;
  if (locale && has(configData, [labelLocaleKey, locale])) {
    return configData[labelLocaleKey][locale];
  }

  return configData[labelKey];
};

export const reportImage = (dispatch, umoID, umoName, locale) => {
  oldExportDownload(
    createTemplateURL(
      _.isString(appConfig.reportImage)
        ? appConfig.reportImage
        : 'KAUI2.Report_Image',
      { INTERNAL_PK: umoID, IMAGE_NAME: umoName },
      locale
    ),
    true
  );
};

export const disableRightClick = (e) => {
  if (appConfig.disableRightClick) {
    e.preventDefault();
    return false;
  }
  return true;
};
